import { Flex } from '@qga/roo-ui/components';
import PointsLogo from '../PointsLogo';
import PointsItem from '../PointsItem';

const NON_POINTS_CLUB_MEMBER_DESCRIPTION = 'Qantas Points earned including bonus';
const POINTS_CLUB_MEMBER_DESCRIPTION = 'Qantas Points earned including bonus as a Points Club member';

const QffPoints = ({ earnedPoints, awardedPoints, pointsClubTier }) => {
  return (
    <Flex flexDirection={['column', 'row']} data-testid="qff-points-section">
      <PointsLogo brand="qff" pointsClubTier={pointsClubTier} />
      <Flex flex="2 0 auto" flexDirection="column" justifyContent="center" width={['100%', '66.666%']}>
        {!!earnedPoints && (
          <PointsItem
            description={pointsClubTier ? POINTS_CLUB_MEMBER_DESCRIPTION : NON_POINTS_CLUB_MEMBER_DESCRIPTION}
            points={earnedPoints}
            data-testid="qff-earned-points"
          />
        )}
        {!!awardedPoints && <PointsItem description="Qantas Points awarded" points={awardedPoints} data-testid="qff-awarded-points" />}
      </Flex>
    </Flex>
  );
};

export default QffPoints;
